@import '../../../globals/main.scss';

pn-quick-cta {
  width: 100%;

  .quick-cta__content {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    gap: 2.4rem;

    width: 100%;

    .quick-cta__content__heading {
      padding: 0;
      margin: 0;

      font-size: 2.4rem;
      font-weight: 500;
      color: $blue900;

      @media screen and (max-width: $min-width-md) {
        display: none;
      }

      @media screen and (min-width: $min-width-xxl) {
        font-size: 2.8rem;
        font-weight: 700;
      }
    }

    .quick-cta__content__preamble {
      font-weight: 400;
      font-size: 1.6rem;
      line-height: 140%;

      padding: 0;
      margin: 0;
      color: $gray900;
    }

    [slot='quick-cta-cta'] {
      a {
        white-space: nowrap;
        &:hover {
          text-decoration: none;
        }
      }
    }
  }
}

//colors
pn-spotlight[data-cta-color='business'] {
  .quick-cta__content__heading {
    color: $blue200;
  }
  .quick-cta__content__preamble {
    color: $blue25;
  }
}

pn-spotlight[data-cta-color='private'] {
  .quick-cta__content__heading,
  .quick-cta__content__preamble {
    color: $white;
  }
}

pn-spotlight[data-cta-color='hybrid'] {
  .quick-cta__content__heading {
    color: $blue700;
  }
  .quick-cta__content__preamble {
    color: $gray900;
  }
}
